import React from 'react';
import Spinner from 'common/components/Spinner';
import { LoadingContainer } from './containers';

export const Fallback: React.FC = () => (
  <LoadingContainer>
    <Spinner />
  </LoadingContainer>
);
